module.exports = __webpack_public_path__ + "fonts/SuisseWorks-Book.aba3959.woff";